import { hasResearchQuestion } from "@/lib/conceptGuidance";
import type { Concept } from "@/types/concept";

/** ① Question · ② Seeds & scope · ③ Check the grading. ("Start" is a display-only pill.) */
export type SetupStep = 1 | 2 | 3;

/** Resume at the question until there is one, else at ② (scope + seeds share it).
 *  Never resumes at ③ — sample grading needs the (unsaved) preview. */
export function resumeStep(concept: Concept | undefined): SetupStep {
  if (!concept || !hasResearchQuestion(concept.abstract)) return 1;
  return 2;
}
